// Custom line icons matching lucide's stroke style (24x24, stroke=currentColor).
const base = (size, strokeWidth, style) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style,
});

export const RoofIcon = ({ size = 18, strokeWidth = 1.5, style, ...rest }) => (
  <svg {...base(size, strokeWidth, style)} {...rest}>
    <path d="M2 12 L12 4 L22 12" />
    <path d="M5 11 v9" />
    <path d="M19 11 v9" />
    <path d="M5 20 h14" />
    <path d="M16 6.4 V4 h2 v3.9" />
  </svg>
);

export const StoveIcon = ({ size = 18, strokeWidth = 1.5, style, ...rest }) => (
  <svg {...base(size, strokeWidth, style)} {...rest}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8" cy="8" r="1.6" />
    <circle cx="16" cy="8" r="1.6" />
    <path d="M3 13 h18" />
    <path d="M8.5 17 h7" />
  </svg>
);

export const BasementIcon = ({ size = 18, strokeWidth = 1.5, style, ...rest }) => (
  <svg {...base(size, strokeWidth, style)} {...rest}>
    <path d="M3 4 L12 3.2 L21 4" />
    <path d="M4 5 v15 h16 V5" />
    <path d="M8 20 v-4 h3 v-4 h5" />
  </svg>
);

export const CUSTOM_ICONS = {
  RoofIcon,
  StoveIcon,
  BasementIcon,
};
